import type { IBenefitConstructorParams } from "@services/sdk";
import { map } from "ramda";

export enum BenefitTypeEnum {
	NONE = 0,
	DOLLARS = 1,
	PERCENTAGE = 2,
}

const mapBenefitTypeEnum: {
	[key: string]: BenefitTypeEnum;
} = {
	DOLLARS: BenefitTypeEnum.DOLLARS,
	PERCENTAGE: BenefitTypeEnum.PERCENTAGE,
};

class Benefit {
	public static ConstructList(
		arrParams: Array<IBenefitConstructorParams>,
	): Array<Benefit> {
		return map(Benefit.Construct)(arrParams);
	}

	public static Construct(params: IBenefitConstructorParams): Benefit {
		return new Benefit(params);
	}

	responseData: IBenefitConstructorParams;

	constructor(params: IBenefitConstructorParams) {
		this.responseData = params;
	}

	get value(): string {
		const responseDataValue = this.responseData.value;
		const value = Number.parseInt(responseDataValue, 10);

		return `${Math.abs(value)}`;
	}

	private get type(): BenefitTypeEnum {
		return mapBenefitTypeEnum[this.responseData.key];
	}

	get isValidType(): boolean {
		return (
			this.type === BenefitTypeEnum.PERCENTAGE ||
			this.type === BenefitTypeEnum.DOLLARS
		);
	}
}

export default Benefit;
